const API_BASE_URL = "https://api.simplif.com";

async function apiRequest(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(options.headers || {}),
    },
  });

  let data = null;

  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    const error = new Error(
      data?.error || "Something went wrong. Please try again."
    );

    error.status = response.status;
    error.code = data?.code || null;
    error.data = data;

    throw error;
  }

  return data;
}

export function register({ email, password, brandName }) {
  return apiRequest("/v1/auth/register", {
    method: "POST",
    body: JSON.stringify({
      email,
      password,
      brandName,
    }),
  });
}

export function resendVerification(email) {
  return apiRequest("/v1/auth/resend-verification", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
}

export function verifyEmail(token) {
  return apiRequest("/v1/auth/verify-email", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
}

export function login({ email, password }) {
  return apiRequest("/v1/auth/login", {
    method: "POST",
    body: JSON.stringify({
      email,
      password,
    }),
  });
}

export function getCurrentUser() {
  return apiRequest("/v1/auth/me", {
    method: "GET",
  });
}

export function logout() {
  return apiRequest("/v1/auth/logout", {
    method: "POST",
  });
}

export function forgotPassword(email) {
  return apiRequest("/v1/auth/forgot-password", {
    method: "POST",
    body: JSON.stringify({ email }),
  });
}

export function resetPassword({ token, password }) {
  return apiRequest("/v1/auth/reset-password", {
    method: "POST",
    body: JSON.stringify({
      token,
      password,
    }),
  });
}

export { API_BASE_URL };
